/* eslint-disable complexity */
import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../../models/book-widget-fields-master-config.interfaces';

export const shopMilesRulesOnChangeEval = (
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  isBusinessUser: boolean
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (updatedBookWidgetFields.shopMilesField.checked) {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexAirportsField: {
        ...updatedBookWidgetFields.flexAirportsField,
        hide: bookWidgetFieldsMasterConfig.flexAirportsField?.hide || false
      }
    };

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      refundableFareField: {
        ...updatedBookWidgetFields.refundableFareField,
        disable: true,
        checked: false
      }
    };

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      meetingEventCodeField: {
        ...updatedBookWidgetFields.meetingEventCodeField,
        hide: true
      }
    };

    if (
      !bookWidgetFieldsMasterConfig.flexDatesField?.disable &&
      !bookWidgetFieldsMasterConfig.flexDatesField?.hide &&
      !updatedBookWidgetFields.flexDatesField.disable &&
      !updatedBookWidgetFields.flexDatesField.hide &&
      !isBusinessUser
    ) {
      updatedBookWidgetFields = {
        ...updatedBookWidgetFields,
        flexDatesField: {
          ...updatedBookWidgetFields.flexDatesField,
          checked: true
        }
      };
    }
  } else {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      refundableFareField: {
        ...updatedBookWidgetFields.refundableFareField,
        disable:
          bookWidgetFieldsMasterConfig.refundableFareField?.disable || false
      }
    };

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      meetingEventCodeField: {
        ...updatedBookWidgetFields.meetingEventCodeField,
        hide: bookWidgetFieldsMasterConfig.meetingEventCodeField?.hide || false
      }
    };

    if (
      !bookWidgetFieldsMasterConfig.flexDatesField?.disable &&
      !bookWidgetFieldsMasterConfig.flexDatesField?.hide &&
      !updatedBookWidgetFields.flexDatesField.disable &&
      !updatedBookWidgetFields.flexDatesField.hide
    ) {
      updatedBookWidgetFields = {
        ...updatedBookWidgetFields,
        flexDatesField: {
          ...updatedBookWidgetFields.flexDatesField,
          checked: false
        }
      };
    }
  }

  return updatedBookWidgetFields;
};
